import { EventsCollectionGrid } from './EventsCollectionGrid.js'
import { EventsCalendar } from '../../../components/index.js'
import { CardCollectionFilterControlsPanel } from "./CardCollectionFilterControlsPanel.js"
import CardCollectionSearchControl from "./CardCollectionSearchControl.js"
import { useEffect, useState } from 'react'
import classnames from 'classnames'
import { useLocation } from 'react-use';


import {
	defaultTo,
	flatten,
	prop,
	intersection,
	uniq
} from 'ramda'

export function EventsCollection(props = {}) {
	const {
		events = [],
		searchControlEnabled = false,
		searchControlPlaceholder = 'Enter keywords',
		searchControlLabel = 'Search',
		filterControlsEnabled = false,
		taxonomyFilters = [],
		href = {},
		columns = 3,
		rows = 3,
		sortByEnabled,
		loadMoreEnabled,
		viewToggleEnabled,
		showOnlyFeatured,
		view: defaultView = 'grid'
	} = props;

	const [filters, setFilters] = useState([])
	const [targetDate, setTargetDate] = useState(Date.now())
	const [view, setView] = useState(defaultView)
	const locationState = useLocation();

	const getTermsFromEvent = e => {
		console.log(e)
		return flatten(defaultTo({}, e._embedded)['wp:term'] || [])
	}

	useEffect(() => {
		console.log({ locationState })
	}, [locationState])

	useEffect(() => {
		console.log(events)
	}, [events])

	// Update filters whenever terms or taxonomies changes
	useEffect(() => {
		if (!events || events.length < 1) return
		if (!filterControlsEnabled) return
		if (!taxonomyFilters) return
		const urlParams = new URLSearchParams(locationState.search)
		const filters = Object.entries(taxonomyFilters)
			.filter(([k, v]) => v)
			.map(([key]) => {
				const options = uniq(flatten(events
					.map(getTermsFromEvent))
					.filter(term => term.taxonomy === key))
					.map(term => ({
						id: term.id,
						label: term.name,
						value: term.slug,
						type: 'checkbox',
						isActive: urlParams && urlParams.get && urlParams?.get(key)?.split(',')?.includes(term.slug) ? true : false
					}))
				return {
					id: key,
					label: `by ${key}`,
					name: key,
					options
				}
			})

		setFilters(filters)

	}, [events, taxonomyFilters, filterControlsEnabled, locationState])

	const getFilteredEvents = (filters, events) => {
		const activeFilters = filters
			.map(f => ([
				f.id,
				f.options
					.filter(prop('isActive'))
					.map(prop('id'))
			]))
			.filter(([key, value]) => value.length > 0)

		if (activeFilters.length < 1) {
			return events
		}

		const filteredEventIds = activeFilters
			.map(([key, value]) => {
				return events
					.filter(event => intersection(event[key] || [], value || []).length > 0)
					.map(prop('id'))
			})
			.reduce((all, curr) => {
				return all.length < 1 ? curr : intersection(all, curr)
			}, [])

		const filteredEvents = events.filter(event => filteredEventIds.includes(event.id))

		return filteredEvents
	}

	return (
		<div className="grid max-w-screen-xl gap-4 mx-auto">
			<div className="grid w-full gap-4 lg:grid-flow-cols grid-cols-1fr-maxcontent">
				<CardCollectionSearchControl
					isEnabled={searchControlEnabled}
					placeholder={searchControlPlaceholder}
					label={searchControlLabel}
				/>
				<div class="grid" style={{
					gridAutoFlow: 'column',
					gridAutoColumns: 'max-content'
				}}>
					<CardCollectionFilterControlsPanel
						isEnabled={filterControlsEnabled}
						filters={filters}
						onChange={(changed) => {
							console.log(changed)
							const urlParams = new URLSearchParams(locationState.search)
							for (const filter of changed.filters) {
								const key = filter.id;
								const value = filter.options.filter(opt => opt.isActive).map(opt => opt.value).join(',')
								urlParams.set(key, value);
							}
							const url = new URL(locationState.href)
							url.search = urlParams.toString()
							history.pushState({}, 'Events', url.toString());
						}}
					/>
					{viewToggleEnabled ? (
						<div class="gap-2 grid-flow-col hidden items-center lg:grid">
							<span class="block font-semibold text-base text-blue">View as:</span>
							<button onClick={() => setView('grid')} class={classnames(
								'p-2 bg-gray-lightest',
								{
									'text-blue': view !== 'calendar',
									'text-gray': view === 'calendar'
								}
							)}>
								<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 52 52" class="w-4 fill-current"><path d="M14.5 4h-9C4.7 4 4 4.7 4 5.5v17c0 .8.7 1.5 1.5 1.5h9c.8 0 1.5-.7 1.5-1.5v-17c0-.8-.7-1.5-1.5-1.5zM30.5 4h-9c-.8 0-1.5.7-1.5 1.5v17c0 .8.7 1.5 1.5 1.5h9c.8 0 1.5-.7 1.5-1.5v-17c0-.8-.7-1.5-1.5-1.5zM46.5 4h-9c-.8 0-1.5.7-1.5 1.5v17c0 .8.7 1.5 1.5 1.5h9c.8 0 1.5-.7 1.5-1.5v-17c0-.8-.7-1.5-1.5-1.5zM14.5 28h-9c-.8 0-1.5.7-1.5 1.5v17c0 .8.7 1.5 1.5 1.5h9c.8 0 1.5-.7 1.5-1.5v-17c0-.8-.7-1.5-1.5-1.5zM30.5 28h-9c-.8 0-1.5.7-1.5 1.5v17c0 .8.7 1.5 1.5 1.5h9c.8 0 1.5-.7 1.5-1.5v-17c0-.8-.7-1.5-1.5-1.5zM46.5 28h-9c-.8 0-1.5.7-1.5 1.5v17c0 .8.7 1.5 1.5 1.5h9c.8 0 1.5-.7 1.5-1.5v-17c0-.8-.7-1.5-1.5-1.5z"></path></svg>
							</button>
							<button onClick={() => setView('calendar')} class={classnames(
								'p-2 bg-gray-lightest',
								{
									'text-gray': view !== 'calendar',
									'text-blue': view === 'calendar'
								}
							)}>
								<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 52 52" class="w-4 fill-current"><path d="M44 7h-5V5c0-1.6-1.3-3-3-3-1.6 0-3 1.3-3 3v2H19V5c0-1.6-1.3-3-3-3-1.6 0-3 1.3-3 3v2H8c-2.2 0-4 1.8-4 4v2.5c0 .8.7 1.5 1.5 1.5h41c.8 0 1.5-.7 1.5-1.5V11c0-2.2-1.8-4-4-4zM46.5 20h-41c-.8 0-1.5.7-1.5 1.5V46c0 2.2 1.8 4 4 4h36c2.2 0 4-1.8 4-4V21.5c0-.8-.7-1.5-1.5-1.5zM21.1 44c-2.4 0-5.1-.9-5.9-2.2-.1-.2-.2-.4-.2-.7 0-.9.8-1.6 1.6-1.6.3 0 .6.1.9.2 1.1.6 2.4 1 3.5 1 2 0 3.1-.9 3.1-2.1 0-1.3-1-1.9-3.3-1.9-1.3.2-2.2-.4-2.2-1.6 0-.9.6-1.5 1.6-1.5 2.1.1 3.6-.4 3.6-1.8 0-1.3-1.3-1.9-3-1.9-1.1 0-2.2.3-3.2.9-.2.2-.5.2-.8.2-.8 0-1.5-.6-1.5-1.5 0-.4.2-.8.5-1.1 1.3-1.1 3.1-1.8 5.4-1.8 3.8 0 6.2 1.7 6.2 4.5 0 2.1-1.8 3.4-3.6 3.8 1.7.2 3.8 1.5 3.8 3.9C27.5 42 25 44 21.1 44zM37 42.1c0 .9-.5 1.9-1.5 1.9-.9 0-1.5-.9-1.5-1.9V31.8l-2.1 1.9c-.3.3-.7.4-1.1.4-.8 0-1.5-.6-1.5-1.5 0-.4.1-.7.4-1l3.8-3.8c.4-.4.9-.7 1.5-.7 1.1 0 2 1 2 2.1v12.9z"></path></svg>
							</button>
						</div>) : null
					}
				</div>
			</div>
			{
				view === 'calendar'
					? (
						<EventsCalendar
							targetDate={targetDate}
							events={getFilteredEvents(filters, events)}
							onTargetDateChange={(newTargetDate) => setTargetDate(newTargetDate)}
						/>
					)
					: (
						<EventsCollectionGrid
							events={getFilteredEvents(filters, events)}
							columns={columns}
							rows={rows}
							loadMoreEnabled={loadMoreEnabled}
						/>
					)
			}

		</div>
	)
}
